var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-inner app-main-page-tab" }, [
    _c(
      "div",
      { staticClass: "app-main-inner-row" },
      [
        _c("el-checkbox", { attrs: { label: _vm.$t("Clearing.Booking") } }),
        _c("el-checkbox", {
          attrs: { label: _vm.$t("Clearing.CustomsClearance") }
        }),
        _c("el-checkbox", { attrs: { label: "MB/L" } }),
        _c("el-checkbox", { attrs: { label: "HB/L" } }),
        _c("el-checkbox", {
          attrs: { label: _vm.$t("Clearing.FormalHouseWaybill") }
        }),
        _c("el-checkbox", { attrs: { label: "VGM" } }),
        _c("el-checkbox", { attrs: { label: "AMS/ENS" } }),
        _c("el-checkbox", { attrs: { label: "HDS" } }),
        _c("el-checkbox", {
          attrs: { label: _vm.$t("Clearing.CommodityInspection") }
        }),
        _c("el-checkbox", { attrs: { label: _vm.$t("Clearing.Fumigation") } }),
        _c("el-checkbox", { attrs: { label: _vm.$t("Clearing.ForeignTrade") } })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "app-main-inner-row" },
      [
        _c(
          "el-form",
          {
            ref: "basicForm",
            staticStyle: { "min-width": "100%" },
            attrs: { "label-position": "left", "label-width": "90px" }
          },
          [
            _c(
              "el-row",
              { attrs: { gutter: 10 } },
              [
                _c(
                  "el-col",
                  { attrs: { xs: 12, sm: 12, md: 12, lg: 6, xl: 6 } },
                  [
                    _c(
                      "fieldset",
                      { staticStyle: { "min-height": "750px" } },
                      [
                        _c("legend", [
                          _vm._v(
                            _vm._s(_vm.$t("Clearing.EntrustedInformation"))
                          )
                        ]),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("Clearing.BusinessNumber") }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Clearing.Client") } },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Clearing.CustomerAttribute")
                            }
                          },
                          [
                            _c("span", [_vm._v("Lv1")]),
                            _vm._v(" "),
                            _c("span", { staticStyle: { color: "#ffc65f" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("Clearing.VipCooperativeCustomer")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v("（未签约）")
                            ])
                          ]
                        ),
                        _c("el-form-item", { attrs: { label: "联系人" } }, [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c(
                                "el-select",
                                { staticStyle: { width: "200px" } },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Clearing.Dropdown"),
                                      value: 0
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    "border-bottom": "1px solid black",
                                    "font-size": "12px"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("Clearing.DetailedInformation")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("CargoMsg.Cargo_FLCLType") }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("CargoMsg.Cargo_CargoType") }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Clearing.OrderChannel") } },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_SailingDate")
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "150px" },
                                  attrs: { type: "date", clearable: "" }
                                }),
                                _c(
                                  "el-select",
                                  { staticStyle: { width: "100px" } },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("Clearing.Dropdown"),
                                        value: 0
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Clearing.ArrivalDate") } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "251px" },
                              attrs: { type: "date", clearable: "" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("Clearing.OperationDate") }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "251px" },
                              attrs: { type: "date", clearable: "" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Clearing.ShippingOfBillOfLading")
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("Clearing.OriginPortPOL") }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "170px" }
                                }),
                                _c(
                                  "el-checkbox",
                                  { staticStyle: { width: "80px" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Clearing.Transshipment"))
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SeaExport.PortOfDischarge")
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("Clearing.DeliveryPlace") }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Clearing.Route") } },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Clearing.FinalDestination")
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("Clearing.ShippingCompany") }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Clearing.BookingAgent") } },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Clearing.ShipAgent") } },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Clearing.CargoType") } },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c(
                                  "el-select",
                                  { staticStyle: { width: "125px" } },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("Clearing.Dropdown"),
                                        value: 0
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-select",
                                  { staticStyle: { width: "125px" } },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("Clearing.Dropdown"),
                                        value: 0
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Clearing.DestinationPortAgent")
                            }
                          },
                          [_c("el-input")],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-col",
                  { attrs: { xs: 12, sm: 12, md: 12, lg: 6, xl: 6 } },
                  [
                    _c(
                      "fieldset",
                      { staticStyle: { "min-height": "750px" } },
                      [
                        _c("legend", [
                          _vm._v(
                            _vm._s(_vm.$t("Clearing.AdditionalInformation"))
                          )
                        ]),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("SeaExport.LocalService") }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "flex-direction": "column",
                                  "padding-left": "10px",
                                  height: "100px",
                                  "border-radius": "5px",
                                  border: "1px solid #dcdcdc",
                                  background: "white"
                                }
                              },
                              [
                                _c("el-checkbox", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Clearing.ContainerPackingWarehouse"
                                      )
                                    )
                                  )
                                ]),
                                _c("el-checkbox", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Clearing.DoorToDoorLoadingCollection"
                                      )
                                    )
                                  )
                                ]),
                                _c("el-checkbox", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("Clearing.SelfPickupSelfDelivery")
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Clearing.WarehouseEntryNumber")
                            }
                          },
                          [
                            _c("el-input"),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "space-between"
                                }
                              },
                              [
                                _c("el-button", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("Clearing.AutomaticAllocation")
                                    )
                                  )
                                ]),
                                _c("el-button", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("Clearing.WarehousingInformation")
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("SeaExport.MblNo3") } },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Clearing.BusinessReferenceNumber")
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("Clearing.ProjectNumber") }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("Clearing.CustomsBroker") }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Clearing.TradeMethod") } },
                          [
                            _c("el-select", [
                              _c("option", {
                                attrs: { label: _vm.$t("Clearing.Dropdown") }
                              })
                            ])
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Clearing.TransportationCompany")
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Clearing.Warehouse") } },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "Clearing.MasterWaybillTransportTerms"
                              )
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "Clearing.HouseWaybillTransportTerms"
                              )
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "Clearing.MasterWaybillFreightTerms"
                              )
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "Clearing.MasterWaybillPaymentLocation"
                              )
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Clearing.HouseWaybillFreightTerms")
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Clearing.HouseWaybillFreightTerms")
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "Clearing.HouseWaybillPaymentLocation"
                              )
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("Clearing.PricingNature") }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Clearing.TradeTerms") } },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("Clearing.CargoDimensions") }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Clearing.SpecialPriceExplanation")
                            }
                          },
                          [_c("el-input")],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-col",
                  { attrs: { xs: 12, sm: 12, md: 12, lg: 6, xl: 6 } },
                  [
                    _c(
                      "fieldset",
                      { staticStyle: { "min-height": "750px" } },
                      [
                        _c("legend", [
                          _vm._v(_vm._s(_vm.$t("Clearing.CargoBoxInformation")))
                        ]),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "Message.NumberOfPiecescommissionactual"
                              )
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "Clearing.GrossWeightEntrustedActual"
                              )
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Clearing.VolumeEntrustedActual")
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Clearing.Packing") } },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Clearing.NumberOfSmallPieces")
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Clearing.SmallPiecePacking")
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Clearing.ChargeableWeightRT")
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Clearing.EnglishProductName")
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("Clearing.ShippingMarks") }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Clearing.HSCode") } },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Clearing.ChineseProductName")
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "" } },
                          [_c("el-input")],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-col",
                  { attrs: { xs: 12, sm: 12, md: 12, lg: 6, xl: 6 } },
                  [
                    _c(
                      "fieldset",
                      { staticStyle: { "min-height": "750px" } },
                      [
                        _c("legend", [
                          _vm._v(
                            _vm._s(_vm.$t("Clearing.OperationInformation"))
                          )
                        ]),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_SalesCompany")
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Clearing.Sales") } },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Clearing.CargoSales") } },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("Clearing.SalesDepartment") }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Clearing.OperatingCompany")
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Clearing.OperatingDepartment")
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Clearing.Operation") } },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("Clearing.CustomerService") }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Clearing.OverseasCustomerService")
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("Clearing.Documentation") }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Clearing.RouteResponsiblePerson")
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Clearing.OperationRequirements")
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("Clearing.OperationTips") }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Clearing.AdditionalFeeTerms")
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "Clearing.WarehouseEntryInformation"
                              )
                            }
                          },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Clearing.Remarks") } },
                          [_c("el-input")],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "" } },
                          [_c("el-input")],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-col",
                  { attrs: { xs: 12, sm: 12, md: 12, lg: 6, xl: 6 } },
                  [
                    _c(
                      "fieldset",
                      { staticStyle: { "min-height": "500px" } },
                      [
                        _c("legend", [
                          _vm._v(_vm._s(_vm.$t("Clearing.CustomInformation")))
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Clearing.CustomField1") } },
                          [
                            _c("el-input", {
                              attrs: { type: "textarea", rows: "5" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Clearing.CustomField2") } },
                          [
                            _c("el-input", {
                              attrs: { type: "textarea", rows: "5" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Clearing.CustomField3") } },
                          [
                            _c("el-input", {
                              attrs: { type: "textarea", rows: "5" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Clearing.CustomField4") } },
                          [
                            _c("el-input", {
                              attrs: { type: "textarea", rows: "5" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { gutter: 10 } },
              [
                _c("el-col", { attrs: { span: 24 } }, [
                  _c("fieldset", [
                    _c("legend", [
                      _vm._v(
                        _vm._s(_vm.$t("Clearing.CustomerShippingInformation"))
                      )
                    ]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "el-form-item-group",
                            staticStyle: { "flex-grow": "1" }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.$t("Clearing.Shipper") } },
                              [
                                _c(
                                  "el-input",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: {
                                          background: "#1890ff",
                                          color: "white"
                                        },
                                        attrs: {
                                          slot: "append",
                                          type: "primary"
                                        },
                                        slot: "append"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("Clearing.CodeRetrieval")
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c("el-input"),
                            _c("el-input"),
                            _c("el-input"),
                            _c("el-input"),
                            _c("el-input"),
                            _c("el-input"),
                            _c("el-input")
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "el-form-item-group",
                            staticStyle: { "flex-grow": "1" }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.$t("Clearing.Shipper") } },
                              [
                                _c(
                                  "el-input",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          slot: "append",
                                          type: "primary"
                                        },
                                        slot: "append"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("Clearing.CodeRetrieval")
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c("el-input"),
                            _c("el-input"),
                            _c("el-input"),
                            _c("el-input"),
                            _c("el-input"),
                            _c("el-input"),
                            _c("el-input")
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "el-form-item-group",
                            staticStyle: { "flex-grow": "1" }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.$t("Clearing.Shipper") } },
                              [
                                _c(
                                  "el-input",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          slot: "append",
                                          type: "primary"
                                        },
                                        slot: "append"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("Clearing.CodeRetrieval")
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c("el-input"),
                            _c("el-input"),
                            _c("el-input"),
                            _c("el-input"),
                            _c("el-input"),
                            _c("el-input"),
                            _c("el-input")
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "el-form-item-group",
                            staticStyle: { width: "570px" }
                          },
                          [
                            _c("el-form-item", {
                              attrs: {
                                label: _vm.$t("Clearing.SecondNotifyParty")
                              }
                            }),
                            _c("el-input", {
                              attrs: { type: "textarea", rows: "5" }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }